// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"17":"16e5e23d","31":"2cc6eddb","211":"111d95ba","319":"6ba72d26","381":"1c9eec70","480":"e6f66bdd","567":"ba6fd0fd","570":"14f5a662","617":"c294deaa","747":"a44d9404","872":"f27f7a54","889":"d502fd05"}[chunkId] + ".chunk.js";
};